import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import * as AppTheme from './tools/dom/app-theme'
import * as Diagnostics from './tools/dom/diagnostics'

import App from './components/App'
import ContextStack from './components/contexts/ContextStack'

// Log all errors in the window, regardless of how or where they arose.
window.onerror = (...args) => Diagnostics.append('Window', args)

// NOTE: Top level await is not allowed, so we use an async iife instead.
// The theme is only set on page load, so a full page reload is necessary to change the theme.
;(async () => {
    if (AppTheme.isDarkTheme()) await import('./style/dark.scss')
    else await import('./style/light.scss')
    await import('primeicons/primeicons.css')

    // As a result of asynchronous theming, we also need to render the app asynchronously.
    createRoot(document.getElementById('root')!).render(
        <StrictMode>
            <ContextStack>
                <App />
            </ContextStack>
        </StrictMode>
    )
})()
